import { EnumLocalStore } from '@/constant/enums';
import modal from '@/plugins/modal';
import { message } from '@/utils/message';
import { localStg } from '@/utils/storage/local';
import axios from 'axios';
import 'babel-polyfill';
import ElementUI, { Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import moment from 'moment'; // 解决时间戳格式
import Vue from 'vue';
import App from './App.vue';
import './assets/css/icon.css';
import i18n from './locales';
import router from './router';

import('./service/request/server');

Vue.config.productionTip = false;
Vue.prototype.$message = Message;
Vue.prototype.$modal = modal;
ElementUI.Dialog.props.closeOnClickModal.default = false;
Vue.use(ElementUI, {
    size: 'small'
});

Vue.prototype.$moment = moment; // 解决时间戳格式
Vue.prototype.$axios = axios;

const skipRoutPathArr = ['/register', '/retrieve', '/login', '/phoneLogin', '/forgetPwd', '/emailLogin', '/emailRegister'];

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    let i18Key = to.meta.i18nKey;
    let title;
    if (i18n) {
        title = i18n.t(i18Key);
    }

    if (!title) {
        title = to.meta.title;
    }
    document.title = title;

    // 获取当前URI中的token和region参数（仅从to.query获取，避免重定向循环）
    const token = to.query.token;
    const region = to.query.region;

    // 如果url中存在token或region，保存后重定向到移除参数的地址
    if ((token || region) && !to.query.setStatus) {
        if (token) {
            localStg.set(EnumLocalStore.jwtTokenName, token);
        }
        if (region) {
            localStg.set(EnumLocalStore.region, region);
        }

        let newQuery = to.query || {};
        delete newQuery.token;
        delete newQuery.region;
        newQuery.setStatus = true;
        // 重定向到根路径，不带参数
        return next({ path: '/', replace: true, query: newQuery });
    }

    //登录前不可进首页
    if (!localStg.get(EnumLocalStore.jwtTokenName)) {
        // 并且进的不是注册页
        if (skipRoutPathArr.indexOf(to.path) === -1) {
            localStg.remove(EnumLocalStore.jwtTokenName);
            message.error(i18n.t('login.loginExpired') || '登录信息过期，请重新登录');
            next('/login');
        }
    }
    next();
});

new Vue({
    router,
    i18n,
    render: (h) => h(App),
    axios
}).$mount('#app');
